import {convertTS, convertTSDayFirst, getMomentDate} from "../../utils/getMomentDate";
import getWeights from "../../utils/getWeights";
import {Chip, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import {getMomentDateFromString} from "../../utils/getMomentDateFromString";
import {GridEditInputCell} from "@mui/x-data-grid-pro";
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import {styled} from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";

let salesorderid = {
    field: 'salesorderid',
    type: 'string',
    disablePadding: false,
    headerName: 'Sales Order #',
    width: 240,
    renderCell: (params) => (
        <Stack direction={"row"} spacing={1} alignItems={'center'}>
            <Typography variant={"body2"}>
                {params.row.salesorderid}
            </Typography>
            {params.row.fedex && (
                [2].includes(params.row.fedexstatus) ?
                    <Chip label="FedEx Hold" size={'small'}/> :
                    <img
                        width={50}
                        height={'100%'}
                        src={`https://content.longboardproducts.com/logo/fedex${params.row.courier_brand === 'fedex_manual' ? '_manual' : ''}.png`}
                        alt={'fedex'}
                    />
            )}
            {params.row.hold_prod && <Chip label={'On Hold'} size={'small'}/>}

        </Stack>
    )
}

let shipmentid = {
    field: 'shipmentid',
    type: 'string',
    disablePadding: false,
    headerName: 'Shipment #',
    width: 100,
}

let finishes = {
    field: 'finishes', type: 'string', disablePadding: false, headerName: 'Finishes', width: 300,
    renderCell: ({row}) => {
        return Array.isArray(row.finishes) ? <Stack direction={"row"} spacing={1}>{(row.finishes?.map((item) => (
                <Chip label={item}/>
            ))
        )}</Stack> : <>{row.finishes}</>
    }
}
export const StyledTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
    },
}));

export function NameEditInputCell(props) {
    const {error} = props;

    return (
        <StyledTooltip open={!!error} title={error}>
            <GridEditInputCell {...props} />
        </StyledTooltip>
    );
}

export function renderEdit(params) {
    return <NameEditInputCell {...params} />;
}

export function validatePriority(value) {
    if (value < 0)
        return 'Minimum value of 0';
    else
        return null
}

let priority = {
    field: 'priority',
    type: 'number',
    disablePadding: false,
    headerName: 'Priority',
    width: 100,
    editable: true,
    preProcessEditCellProps: (params) => {
        const errorMessage = validatePriority(+params.props.value);
        return {...params.props, error: errorMessage};
    },
    renderEditCell: renderEdit,
    renderCell: (params) => (
        <Stack direction={"row-reverse"} alignItems={"center"}>
            <IconButton sx={{color: '#afaeae'}} size={"small"}><EditIcon fontSize='inherit'/></IconButton>
            <Typography variant={"body2"}>{params.row.priority}</Typography>
        </Stack>),
}

let destination = {field: 'destination', numeric: false, disablePadding: false, headerName: 'Destination', width: 120}
let customer = {field: 'accountname', numeric: false, disablePadding: false, headerName: 'Customer', width: 120}

let courier = {field: 'courier_name', numeric: false, disablePadding: false, headerName: 'Courier', width: 120}

let bundles = {
    field: 'bundles',
    numeric: true,
    disablePadding: false,
    headerName: 'Bundles',
    width: 120,
}
let po = {
    field: 'po',
    numeric: true,
    disablePadding: false,
    headerName: 'PO',
    width: 120,
}

let weightkg = {
    field: 'weightkg',
    numeric: false,
    disablePadding: false,
    headerName: 'Weight',
    width: 120,
    renderCell: getWeights
}

let epoc_created = {
    field: 'epoc_created',
    disablePadding: false,
    headerName: 'Created',
    width: 120,
    valueFormatter: getMomentDate,

}

let target_arrival = {
    field: 'target_arrival',
    disablePadding: false,
    headerName: 'Target Arrival',
    width: 120,
    valueFormatter: getMomentDateFromString,
}

let epoc_requested = {
    field: 'epoc_requested',
    disablePadding: false,
    headerName: 'Requested',
    width: 120,
    valueFormatter: getMomentDate,
}

let epoc_pickupest = {
    field: 'epoc_pickupest',
    disablePadding: false,
    headerName: 'Pickup (est)',
    width: 120,
    valueFormatter: getMomentDate,
}

let epoc_pickedup = {
    field: 'epoc_pickedup',
    disablePadding: false,
    headerName: 'Picked Up',
    width: 120,
    valueFormatter: convertTS,
}

let epoc_packed = {
    field: 'epoc_packed',
    numeric: false,
    headerName: 'Packed',
    width: 120,
    valueFormatter: convertTS
}

let epoc_deliveryest = {
    field: 'epoc_deliveryest',
    numeric: false,
    headerName: 'Delivery (est)',
    width: 120,
    valueFormatter: convertTS,
}

let epoc_packby = {
    field: 'epoc_packby',
    numeric: false,
    headerName: 'Pack By',
    width: 120,
    valueFormatter: getMomentDate,
}

let not_before = {
    field: 'not_before',
    type: 'boolean',
    headerName: 'Not Before',
    width: 120,
}

let epoc_delivered = {
    field: 'epoc_delivered',
    numeric: false,
    headerName: 'Delivery',
    width: 120,
    valueFormatter: convertTS,
}

let bolnum = {
    field: 'bolnum',
    type: 'string',
    disablePadding: false,
    headerName: 'BOL',
    width: 120,
}

export {
    salesorderid,
    shipmentid,
    destination,
    courier,
    bundles,
    weightkg,
    epoc_created,
    target_arrival,
    epoc_requested,
    epoc_pickupest,
    epoc_pickedup,
    epoc_deliveryest,
    epoc_delivered,
    bolnum,
    epoc_packed,
    not_before, po, customer, priority, finishes, epoc_packby
};